const startMeme = [       
  'https://i.redd.it/k4p6vs2pjcl21.jpg',          
  'https://s3.amazonaws.com/libapps/accounts/63707/images/21392935.jpg',          
  'http://uniteordie-usa.com/wp-content/uploads/2018/03/Fake-News-was-Fake-News-600x483.jpg',          
  'https://memegenerator.net/img/instances/76132312/its-not-fake-news-if-you-believe-it.jpg',          
  'http://www.quickmeme.com/img/dc/dc0661cfb308e3d978496f460e3f014c7e624c85239fbe6b96dab69fbd0c2713.jpg',          
  'https://i.imgflip.com/25d69t.jpg',          
  'https://i.imgflip.com/25dfr7.jpg',          
  'https://media0.giphy.com/media/OqAeQrGmU7lS6tENnQ/giphy.gif',          
  'https://meme.xyz/uploads/posts/t/l-21806-you-are-fake-news.jpg',          
  'https://i.imgflip.com/22g6az.jpg',          
  'https://miro.medium.com/max/962/1*aiVVFTXm1X_kdPfpzRG4-Q.png'       
]

export default startMeme